import { render, staticRenderFns } from "./PriceChangeEffects.vue?vue&type=template&id=57a37268&scoped=true"
import script from "./PriceChangeEffects.vue?vue&type=script&lang=js"
export * from "./PriceChangeEffects.vue?vue&type=script&lang=js"
import style0 from "./PriceChangeEffects.vue?vue&type=style&index=0&id=57a37268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a37268",
  null
  
)

/* custom blocks */
import block0 from "./PriceChangeEffects.vue?vue&type=custom&index=0&blockType=v-spacer"
if (typeof block0 === 'function') block0(component)
import block1 from "./PriceChangeEffects.vue?vue&type=custom&index=1&blockType=div&class=pce__win"
if (typeof block1 === 'function') block1(component)
import block2 from "./PriceChangeEffects.vue?vue&type=custom&index=2&blockType=div&v-for=e%20in%20entries&%3Akey=e.id&class=pce__entry"
if (typeof block2 === 'function') block2(component)

export default component.exports